<template>
    <div class="aboutUsPage">

        <div v-if="page !== null" class="page container" data-page="about">

            <!--Breadcrumbs-->
            <div class="breadcrumbs">
                <router-link to="/">Home</router-link>
                <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
                <router-link to="/about">About Us</router-link>
            </div>
            
            <h1 class="title">{{ page.data.title[0].text }}</h1>

            <div class="mainPhoto image" :style="{'backgroundImage': 'url('+ page.data.main_image.url +')'}"></div>

            <h4 class="mission">
                <span>Our Mission</span><br>
                {{ page.data.mission_statement[0].text }}
            </h4>

            <h4>Organizers and Staff</h4>
            <MembersList type="staff" grid="4"></MembersList>

            <div v-if="page.data.gallery.length > 0" class="aboutSliderArea">
                <h4>Some event photos</h4>
                <Slider v-if="showSlider" type="about" :data="page.data.gallery"></Slider>
            </div>

            <h4>Contact &amp; Follow Us</h4>
            <div class="pure-g contact">

                <div class="pure-u-1 pure-u-lg-1-4">
                    <div class="contactItem">
                        <div class="contactItemInner">
                            <ion-icon name="mail"></ion-icon>
                            <h4>Email Us</h4>
                            <a href="mailto:info@onemgl.com" class="btn green">info@onemgl.com</a>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1 pure-u-lg-1-4">
                    <div class="contactItem">
                        <div class="contactItemInner">
                            <ion-icon name="logo-instagram"></ion-icon>
                            <h4>Instagram</h4>
                            <a href="https://www.instagram.com/onemglcom/" target="_blank" class="btn green">Follow</a>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1 pure-u-lg-1-4">
                    <div class="contactItem">
                        <div class="contactItemInner">
                            <ion-icon name="logo-facebook"></ion-icon>
                            <h4>Facebook</h4>
                            <a href="https://www.facebook.com/onemglcom" target="_blank" class="btn green">Like Us</a>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1 pure-u-lg-1-4">
                    <div class="contactItem">
                        <div class="contactItemInner">
                            <ion-icon name="logo-youtube"></ion-icon>
                            <h4>Youtube</h4>
                            <a href="https://www.youtube.com/channel/UCjyVpUoJtbVBYcOeC58qG3Q" target="_blank" class="btn green">Subscribe</a>
                        </div>
                    </div>
                </div>

            </div>

            <h4 class="mission">
                “The greatness of a community is most accurately measured by the compassionate actions of it's members.”
            </h4>

        </div>

        <svg class="item1" xmlns="http://www.w3.org/2000/svg" width="544.656" height="549.005" viewBox="0 0 544.656 549.005"><path d="M167.941,0C375.995,0,544.656,168.661,544.656,376.714a375.757,375.757,0,0,1-40.731,170.556,1.581,1.581,0,0,0,0,1.735H33.546s-2.367-1.05-3.862-1.735c-22.643-5.923-26.661-21.9-29.59-32.648a18.417,18.417,0,0,1,0-3.465V41.325s-.11-1.928,3.939-3.893A374.812,374.812,0,0,1,167.941,0Z" transform="translate(544.656 549.005) rotate(180)" fill="#e5554a"/></svg>
        <svg class="item2" xmlns="http://www.w3.org/2000/svg" width="372.238" height="500" viewBox="0 0 372.238 500"><path d="M250,0C388.071,0,500,111.929,500,250S388.071,500,250,500a248.834,248.834,0,0,1-117.915-29.5h0l-.069-440.909h0A248.262,248.262,0,0,1,250,0Z" transform="translate(-127.762)" fill="#34aa59"/></svg>
        <svg class="item3" xmlns="http://www.w3.org/2000/svg" width="368.256" height="396.554" viewBox="0 0 368.256 396.554"><g transform="translate(0.256 -524)"><path d="M180.793,0C303.5,0,402.975,99.474,402.975,222.181a221.617,221.617,0,0,1-24.022,100.592.933.933,0,0,0,0,1.023H101.529s-1.4-.619-2.277-1.023C85.9,319.28,83.527,309.858,81.8,303.518a10.862,10.862,0,0,1,0-2.043V24.373s-.065-1.137,2.323-2.3A221.06,221.06,0,0,1,180.793,0Z" transform="translate(-82 596.758)" fill="#ffc107" opacity="0.698"/><circle cx="119" cy="119" r="119" transform="translate(130 524)" fill="#34aa59"/></g></svg>
    </div>
</template>

<script>
    import MembersList from '../components/MembersList.vue'
    import Slider from '../components/Slider.vue'
    
    export default {
        components: {
            MembersList,
            Slider
        },
        data(){
            return{
                page: null,
                showSlider: false,
                sliderItems: []
            }
        },
        mounted(){
            this.$prismic.client.getSingle('about_us').then((document) => {
                this.page = document
                this.sliderItems = document.data.gallery
                this.showSlider = true
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/About.vue